import { render, staticRenderFns } from "./RiskhubForm.vue?vue&type=template&id=512ad9f2&"
import script from "./RiskhubForm.vue?vue&type=script&lang=js&"
export * from "./RiskhubForm.vue?vue&type=script&lang=js&"
import style0 from "./RiskhubForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports